import { apiEmpleo } from "../../util/ApiEmpleo";

const apiDeleteEmployeeAvatar = async (employeeId: string) => {
  const res = await apiEmpleo.delete(`/avatars/${employeeId}`);

  return res;
};

export { apiDeleteEmployeeAvatar };
